const key = 'langtan-auth';

interface AuthState {
  tokenName: string;
  tokenValue: string;
  staffId: number;
}

export const storageAuth = {
  get<T = AuthState | null>() {
    const value = localStorage.getItem(key);
    if (!value) {
      return;
    }
    try {
      const parsedValue: T = JSON.parse(value);
      return parsedValue;
    } catch (error) {
      console.error('Failed to parse storage value:', error);
      return;
    }
  },
  set(value: AuthState) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  remove(key: string) {
    localStorage.removeItem(key);
  },
};
